<template>
  <div class="manager-feed-item-display col-12">
    <div class="card card-default mb-4">
      <div class="card-body">
        <template v-if="feedItem.Property">
          <router-link :to="'/database-manager/properties/' + feedItem.PropertyUuid">
            <h5>
              <strong>{{ feedItem.Property.address }}</strong>
            </h5>
          </router-link>  
          {{ action }}
        </template>
        <hr>
        <p v-if="feedItem.verb === 'updated'">
          <strong>{{ feedItem.attributeName }}:</strong> 
          {{ oldValue }} <i class="fas fa-arrow-circle-right fa-fw red"></i> {{ newValue }}
        </p>
        <router-link :to="'/database-manager/companies/' + feedItem.Property.CompanyUuid + '#managers'">
          <strong>{{ feedItem.ManagerResponsible.fullName }}</strong>
        </router-link>  
        <br/><span class="text-muted small"><i class="far fa-clock fa-fw"></i> {{ feedItem.createdAt | date_time_format }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ManagerFeedItemDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      action () {
        return this.feedItem.verb.charAt(0).toUpperCase() + this.feedItem.verb.slice(1)
      },
      feedItem () {
        return {
          ...this.object
        }
      },
      oldValue () {
        if (this.feedItem.oldValue) {
          return this.feedItem.oldValue
        }
        return 'NULL'
      },
      newValue () {
        if (this.feedItem.newValue) {
          return this.feedItem.newValue
        }
        return 'NULL'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/ManagerFeedItem.vue